// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__kQXYr","file":"styles_file__2s1Mt"};